import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class EmployeeService extends BaseService {
    static async getEmployees(params = {}) {
        const res = await this.get(`/employees`, params);
        return unwrapResponse(res);
    }
    static async getUsers(params = {}) {
        const res = await this.get(`/users/votes`, params);
        return unwrapResponse(res);
    }
}
